<template>
  <b-modal
    id="scriv-pro-book-purchase-modal"
    :modal-class="modalClasses"
    :hide-footer="true"
    @shown="shown"
    @hidden="hidden"
  >
    <template v-slot:modal-title>
      Liberar com Scriv Pro
    </template>

    <template v-slot:default>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <div class="text-center">
        <div class="font-size-small">
          <template v-if="book.is_scriv_pro_purchase_available">
            <p>
              Você está prestes a liberar o livro <span class="font-weight-bold text-color2">{{ book.title }}</span> utilizando sua assinatura Scriv Pro!
            </p>
            <p>
              É importante lembrar que você possui uma compra de livro por mês utilizando a assinatura.
            </p>
            <p>
              Tem certeza que deseja continuar?
            </p>
            <div class="mt-3">
              <Button
                class="btn-primary btn-sm"
                type="button"
                @click="submit"
                :loading="loader"
                :disabled="!book.is_scriv_pro_purchase_available"
              >
                Liberar com Scriv Pro
              </Button>
            </div>
          </template>
          <template v-else>
            <p>
              Infelizmente você já utilizou a sua compra do mês. Por favor, espere o novo ciclo da sua assinatura para fazer uma nova!
            </p>
          </template>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>

import BooksService from '@/modules/books/services/books-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'
import { mapState } from 'vuex'

import AlertWraper from '@/components/common/Alert/AlertWraper.vue'
import Button from '@/components/common/Button/Button.vue'

export default {
  name: 'ScrivProBookPurchaseModal',
  props: ['book'],
  components: {
    AlertWraper,
    Button
  },
  data () {
    return {
      errors: null,
      loader: false
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState({
      nightMode: state => state.nightMode
    }),
    modalClasses () {
      return {
        'default-modal': true
      }
    }
  },
  methods: {
    /**
     * On hidden modal
     */
    hidden () {
      this.reset()
    },
    /**
     * Reset variables
     */
    reset () {
      this.errors = null
    },
    /**
     * Submit and request epub be sent to kindle
     */
    async submit () {
      this.loader = true
      try {
        await BooksService.purchaseBookWithScrivPro(this.book.id)
        this.$bvModal.hide('scriv-pro-book-purchase-modal')
        const notification = {
          notification: {
            type: 'success',
            content: 'Compra realizada com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$emit('purchase-completed', null)
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    /**
     * On shown modal
     */
    shown () {}
  }
}
</script>
